module.exports = __webpack_public_path__ + "static/01-27b6736bcc26e021dc7e32c2a745a37f.jpg";